import React, { Component } from "react";
import { arrayOf, shape, number, string, func } from "prop-types";
import { Button, ButtonGroup, Input } from "reactstrap";

import {
  approveVerificationRequest,
  rejectVerificationRequest,
} from "../../util/verificationRequestHelper";

class ApproveOrRejectGroup extends Component {
  static propTypes = {
    limitsList: arrayOf(
      shape({ id: number.isRequired, limitName: string.isRequired }),
    ).isRequired,
    verificationId: number.isRequired,
    callback: func.isRequired,
    accountType: string.isRequired,
    requestStatus: string,
  };

  state = {
    selectedLimitId: undefined,
  };

  onLimitChange = ({ target: { value } }) => {
    this.setState({ selectedLimitId: value });
  };

  render() {
    const { selectedLimitId } = this.state;
    const {
      limitsList,
      verificationId,
      callback,
      accountType,
      requestStatus,
    } = this.props;

    const limitsOptionsForSelectedUserType = limitsList
      .filter(
        l => l.accountType === accountType && l.kycStatus !== requestStatus,
      )
      .map(l => (
        <option key={l.id} value={l.id}>
          {l.limitName}
        </option>
      ));

    return (
      <ButtonGroup size="sm">
        <Input
          style={{ width: 80 }}
          type="select"
          value={selectedLimitId}
          onChange={this.onLimitChange}
          data-cy="limit-selector">
          <option value={""}>Not selected</option>
          {limitsOptionsForSelectedUserType}
        </Input>
        <Button
          color="success"
          disabled={!selectedLimitId}
          onClick={() =>
            approveVerificationRequest(
              { verificationId, limitId: Number(selectedLimitId) },
              callback,
            )
          }
          data-cy="approve">
          Approve
        </Button>
        <Button
          color="danger"
          onClick={() => rejectVerificationRequest(verificationId, callback)}
          data-cy="reject">
          Reject
        </Button>
      </ButtonGroup>
    );
  }
}

export default ApproveOrRejectGroup;
